import React, { Component } from 'react';

class MatrixDeviceTable extends Component {
    render() {
        const { testInstance, devices, devicesShowing, sort, sortAsc, toggleSelectDevice, toggleShowDevice, updateSort, toggleShowAllDevices } = this.props;

        let arrow;
        if (sortAsc) {
            arrow = <span className="glyphicon glyphicon-triangle-bottom" title="Active" />;
        } else {
            arrow = <span className="glyphicon glyphicon-triangle-top" title="Inactive" />;
        }

        const deviceListTableContents = devices.map(device => {
            let testInstanceDevice = testInstance.devices.find(
                testInstanceDevice => testInstanceDevice.deviceId === device._id,
            );
            let osVersion = '';
            let sdkVersion = '';
            if (testInstanceDevice !== undefined && testInstanceDevice.systemState !== undefined) {
                osVersion = testInstanceDevice.systemState.osVersion;
                sdkVersion = testInstanceDevice.systemState.sdkVersion;
            }

            return (
                <div
                    key={device._id}
                    className={
                        'row matrix-device-list-row' +
                        (device.isSelected ? ' on' : ' off') +
                        (device.isShowing ? '' : ' not-clickable')
                    }
                    onClick={() => toggleSelectDevice(device._id)}
                >
                    <div className="text-center col-sm-2 center-vertical">
                        <input
                            type="checkbox"
                            className="checkbox-center"
                            onChange={() => toggleShowDevice(device._id)}
                            checked={device.isShowing}
                        />
                    </div>
                    <div className="text-center col-sm-2 center-vertical">{device.name}</div>
                    <div className="text-center col-sm-2 center-vertical">{osVersion}</div>
                    <div className="text-center col-sm-2 center-vertical">{sdkVersion}</div>
                    <div className="text-center col-sm-4 center-vertical">{device.model}</div>
                </div>
            );
        });

        return (
            <div id="available-device-list-table">
                <h4>Available Devices</h4>
                <div key="available-device-list-head" className="device-list-head">
                    <div className="text-center table-header col-sm-2">Show?</div>
                    <div
                        className="text-center table-header table-header-clickable col-sm-2"
                        onClick={() => updateSort('name')}
                    >
                        Name {sort === 'name' ? arrow : ''}
                    </div>
                    <div
                        className="text-center table-header table-header-clickable col-sm-2"
                        onClick={() => updateSort('osVersion')}
                    >
                        OS Version {sort === 'osVersion' ? arrow : ''}
                    </div>
                    <div
                        className="text-center table-header table-header-clickable col-sm-2"
                        onClick={() => updateSort('sdkVersion')}
                    >
                        SDK Version {sort === 'sdkVersion' ? arrow : ''}
                    </div>
                    <div
                        className="text-center table-header table-header-clickable col-sm-4"
                        onClick={() => updateSort('model')}
                    >
                        Model {sort === 'model' ? arrow : ''}
                    </div>
                </div>
                <div
                    key="available-device-list-table-selector"
                    className="row matrix-device-list-row off not-clickable select-all-or-none"
                >
                    <div className="text-center col-sm-2 center-vertical">
                        <input
                            type="checkbox"
                            className="checkbox-center"
                            onChange={toggleShowAllDevices}
                            checked={devices.every(({ isShowing }) => isShowing)}
                        />
                    </div>
                    <div className="text-center col-sm-10 center-vertical bold">
                        Showing {devicesShowing.length} / {devices.length}
                    </div>
                </div>
                <div className="main-table">{deviceListTableContents}</div>
            </div>
        );
    }
}

export default MatrixDeviceTable;
